import { type MouseEvent, useCallback } from 'react';
import { useRepubContext } from '@cx-web/feature-repub';

import { type Bet } from '~/components/BettingInsights/types';

export const useClickoutBet = ({
  bet,
  onClick,
}: {
  bet: Bet;
  onClick?: (e: MouseEvent<HTMLButtonElement>) => void;
}) => {
  const { repub } = useRepubContext();

  const handleClick = useCallback(
    (e: MouseEvent<HTMLButtonElement>) => {
      const clickoutUrl = `/api/cx/whoscored/clickout-bet?repub=${repub}&betId=${bet.betId}&bookmakerCode=${bet.bookmakerCode}`;

      window.open(clickoutUrl, '_blank');

      onClick?.(e);
    },
    [repub, bet.betId, bet.bookmakerCode, onClick],
  );

  // Clickout repubs have no betslip concept - always return false
  return { handleClick, isBetInBetslip: false };
};
